// extracted by mini-css-extract-plugin
export var dropdown = "_ve-0";
export var imageWrapper = "_ve-3";
export var itemNameContainer = "_ve-1";
export var productImage = "_ve-2";
export var spinnerWrapper = "_ve-4";